import 'isotope-layout/dist/isotope.pkgd.min.js';

const beitraegeArchive = function() {
  console.log('hello from common');

  setTimeout(function() {
    setupIsotope();
    setupFilter();
    setupLoadMore();
  }, 500)

  $(window).on('resize', function() {
  
  })

  function setupFilter() {
    // toggle filter 
    $('.filter-toggle').unbind();
    $('.filter-toggle').click(function() {
      $(this).toggleClass('open')
      $('.filter-container').toggleClass('open')
    });

    // radio input clicks
    $('input[name="post-filter"]').on('change', function() {
      let filterVal = $(this).val();
      $('.grid').isotope({ filter: (filterVal != '*' ? `.${filterVal}` : filterVal)});
    })
  }

  function setupIsotope() {
    $('.grid').isotope({
      itemSelector: '.grid-item',
    });
  }

  function setupLoadMore() {
    $('.load-more').unbind();
    $('.load-more').click(function(e) {
      let currentTarget = e.currentTarget;
      let pageCount = parseInt($(currentTarget).attr('data-page')); 
      console.log(pageCount);
      let url = window.location.protocol + '//' + window.location.host + '/wp-admin/admin-ajax.php';

      $.ajax({
        type: 'POST',
        url: url,
        data: {
          'action': 'get_beitraege',
          'page': pageCount,
        },
        success: function(data) {
          console.log(data);
          let newPage = pageCount + 1;
          $(currentTarget).attr('data-page', newPage);

          if(!data.postsLeft) {
            $(currentTarget).attr('disabled', true);
          }

          data.beitraege.forEach(function(item) {
            let $item = $(item);
            $('.grid').append($item).isotope('appended', $item);
          });

          setTimeout(function() {
            $('.grid').isotope();
          }, 250)
        },
      });
    });
  }
}

export default beitraegeArchive



// WEBPACK FOOTER //
// ./scripts/barba-views/beitraege-archive.js